<template>
    <ui-Programming
        :modeHeat="program.isModeHeat()"
        :start.sync="program.time_start"
        :end.sync="program.time_stop"
        :days="{ '1': 'L', '2': 'M', '3': 'M', '4': 'J', '5': 'V', '6': 'S', '7': 'D' }"
        :activeAdays.sync="program.days"
        :resetText="$dicc.devicePanel.resetPrograms"
        :saveText="$dicc.devicePanel.savePrograms"
        @save="save()"
        @delete="remove()"
    >
        <template v-slot:programmingOrder>
            <ui-IcoBtn
                v-if="status.allowHeat()"
                :active="program.isModeValid() && program.isModeHeat()"
                valueIco="mode-heat"
                @click="program.setHot()"
            />
            <ui-IcoBtn
                v-if="status.allowCool()"
                :active="program.isModeValid() && !program.isModeHeat()"
                classStyles="ms-1"
                valueIco="mode-cool"
                @click="program.setCool()"
            />
            <ui-IcoBtn
                v-if="status.allowAC()"
                :active="program.isModeAC()"
                classStyles="ms-3"
                valueIco="ac"
                @click="program.toggleAC()"
            ></ui-IcoBtn>
            <ui-IcoBtn
                v-if="status.allowFloor()"
                :active="program.isModeFloor()"
                classStyles="ms-1"
                valueIco="radiatingFloor"
                @click="program.toggleRadiatingFloor()"
            ></ui-IcoBtn>
            <!--
            <ui-IcoBtn
                v-if="program.allowFan()"
                :active="program.hasFanMode()"
                classStyles="ms-1"
                valueIco="ventilation"
                @click="program.toggleFan()"
            ></ui-IcoBtn>
            -->
            <ui-TempControlInstallation
                :active="true"
                :min="program.temperature_min | toNumber"
                :max="program.temperature_max | toNumber"
                :order="program.temperature | toNumber"
                @update:order="program.updateOrder($event)"
            ></ui-TempControlInstallation>
        </template>
        <template v-slot:programmingSwitch>
            <ui-Switch :status="program.isOn()" @update:status="program.togglePower($event)"></ui-Switch>
        </template>
    </ui-Programming>
</template>

<script>
    import Device from '../models/Device';
    import { MqttMixin } from '../mixins/MqttMixin';

    export default {
        name: 'Program',
        mixins: [MqttMixin],
        props: {
            program: Object,
            installationRef: String,
            deviceRef: String,
            status: Device,
        },
        components: {},
        methods: {
            save: function() {
                this._sendInstruction(
                    this.installationRef,
                    this.deviceRef,
                    'update-program',
                    this.program,
                    () => {
                        this.$emit('update', () =>
                            this.$toast({
                                message: 'Programacion actualizada',
                                type: 'is-success',
                            })
                        );
                    },
                    (error) => {
                        this.$toast({
                            message: error,
                            type: 'is-white',
                        });
                    }
                );
            },
            remove: function() {
                this._sendInstruction(
                    this.installationRef,
                    this.deviceRef,
                    'delete-program',
                    this.program,
                    () => {
                        this.$emit('update', () =>
                            this.$toast({
                                message: 'Programacion eliminada',
                                type: 'is-success',
                            })
                        );
                    },
                    (error) => {
                        this.$toast({
                            message: error,
                            type: 'is-black',
                        });
                    }
                );
            },
        },
        // filters: {
        //     toNumber(value) {
        //         return parseInt(value);
        //     },
        // },
    };
</script>
